import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-salesService",
  "use": "icon-salesService-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-salesService\">\n  <path d=\"M5 13v-2a7 7 0 0 1 14 0v2\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" />\n  <path d=\"M5 13.5a2 2 0 0 1 2-2h1v5H7a2 2 0 0 1-2-2v-1ZM19 13.5a2 2 0 0 0-2-2h-1v5h1a2 2 0 0 0 2-2v-1Z\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linejoin=\"round\" />\n  <path d=\"M16 18.5h-2.2a2 2 0 0 1-1.8 1.1h-1\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol